import SharingMethods from './SharingMethods';

export default SharingMethods;
